import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  Avatar,
  Button,
  CkTextEditor,
  Drawer,
  FileUploadNew,
  InfoText,
  Modal,
  showToast,
} from "../../../../../components";
import { keyToTitle } from "../../../../../utils";
import pic from "../../../../../assets/images/profile-dummy.png";

const TicketDetails = () => {
  const [escalateModal, setEscalateModal] = useState(false);
  const [addConcern, setAddConcern] = useState(false);
  const navigate = useNavigate();
  let generalTicketDetails = [
    {
      "Ticket Title": "VMS Issue",
      Status: "Waiting for Response",
      "Assigned To": "Swati Reddy",
      "Assigned On": "Oct 12, 2025 15:30 PM",
    },
  ];
  return (
    <div>
      <div className="flex justify-between items-center mr-4 mt-3">
        <Button
          title="Ticket ID: 13623"
          color="black"
          variant="text"
          size="md"
          fromLeft
          icon="arrow_left_alt"
          className="self-start text-md font-semibold !px-2.5"
          // onClick={() => {
          //   navigate("/ats/help#my-tickets");
          // }}
          onClick={() => {
            navigate("/ats/help?help=my-tickets");
          }}
        />
        <div className="flex gap-2">
          <Button
            variant="outlined"
            title={"Add Concern"}
            size="sm"
            onClick={() => setAddConcern(true)}
          />
          <Button
            title={"Escalate this ticket"}
            size="sm"
            onClick={() => setEscalateModal(true)}
          />
        </div>
      </div>
      <div className="mx-3 grid grid-cols-5 gap-5 my-2  inner-section p-4 rounded-lg mb-4">
        {Object.entries(generalTicketDetails[0]).map(([key, value]) => {
          return (
            <InfoText
              size="sm"
              key={key}
              title={keyToTitle(key)}
              value={value}
              textWrap
            />
          );
        })}
      </div>
      <div className="flex flex-col gap-5 my-2 mx-3 inner-section p-4 rounded-lg">
        <div className="flex items-center gap-4">
          <Avatar src={pic} />
          <div className="flex flex-col gap-1">
            <h6 className="text-md font-semibold">Astha Vaish</h6>
            <p className="text-xs text-neutrals-500">
              Today,Oct 25, 2025 13.30 PM
            </p>
          </div>
        </div>
        <div className="flex flex-col flex-1 px-12 py-2 max-w-xl">
          <p className="mb-4 text-xs">Hi Vikranth</p>
          <p className="text-xs mb-3">
            Lorem ipsum dolor sit amet consectetur adipisicing elit. Inventore
            numquam assumenda corrupti nam odio temporibus accusamus in iusto
            ratione, necessitatibus recusandae at quia molestiae similique
            ducimus distinctio doloremque exercitationem hic.
          </p>
          <p className="text-xs">
            Thank you for your attention to this matter
            <br />
            Regards,
            <br />
            Astha Vaish
            <br />
            Ph- 7256636590
          </p>
        </div>
        <hr className="text-gray-300 " />
        <div className="flex items-center gap-4">
          <Avatar showInitials alt={"Vikranth Desireddy"} />
          <div className="flex flex-col gap-1">
            <h6 className="text-md font-semibold">Vikranth Desireddy</h6>
            <p className="text-xs text-neutrals-500">
              Replied: Today,Oct 25, 2025 16.45 PM
            </p>
          </div>
        </div>
        <div className="flex flex-col flex-1 rounded px-12 py-2 max-w-xl">
          <p className="mb-4 text-xs">Hi Astha</p>
          <p className="text-xs mb-3">
            Lorem ipsum dolor sit amet consectetur adipisicing elit. Inventore
            numquam assumenda corrupti nam odio temporibus accusamus in iusto
            ratione, necessitatibus recusandae at quia molestiae similique
            ducimus distinctio doloremque exercitationem hic.
          </p>
          <p className="text-xs">
            Thank you for your attention to this matter
            <br />
            Regards,
            <br />
            Vikranth
            <br />
            Ph- 7256636590
          </p>
        </div>
      </div>
      <Modal isOpen={escalateModal} showCloseButton={false}>
        <div className="flex flex-col justify-center items-center gap-2 py-8 px-4">
          <span className="material-symbols-outlined !text-7xl !text-warning">
            info
          </span>
          <h5 className="font-semibold"> Confirmation</h5>
          <p className="text-xs text-center">
            Are You sure you want to proceed?
          </p>
          <div className="flex gap-4 my-2">
            <Button
              title={"Cancel"}
              variant="outlined"
              size="sm"
              onClick={() => setEscalateModal(false)}
            />
            <Button
              title={"Confirm"}
              size="sm"
              onClick={() => {
                setEscalateModal(false);
                showToast(
                  "Your escalation has been notified to the team. We will take immediate action and we will revert back again with an update asap.",
                  "success"
                );
              }}
            />
          </div>
        </div>
      </Modal>
      <Drawer
        isOpen={addConcern}
        title={"Add Concern"}
        onClose={() => setAddConcern(false)}
        width="w-4xl"
      >
        <p className="text-sm font-semibold m-1">
          Please enter your concern here with required attachment
        </p>
        <CkTextEditor />

        <FileUploadNew title="Add Attachment" />
        <div className="flex justify-end gap-4 m-4">
          <Button
            title={"Cancel"}
            variant="outlined"
            size="sm"
            onClick={() => setAddConcern(false)}
          />
          <Button title={"Save"} size="sm" />
        </div>
      </Drawer>
    </div>
  );
};

export default TicketDetails;
